<!-- <div *ngIf="loading$ | async" class="spinner">
  <mat-spinner></mat-spinner>
</div> -->
<div *ngIf="showLoadingPopup" class="popup">
  Please wait while we download user access data...
    <div class="spinner">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>

</div>

<mat-card class="mat-card-sub" matTooltip="Assign Libraries to Users">
<h1>Manage User Access</h1>



<div class="table__container" *ngIf="!showLoadingPopup">
  <mat-form-field style="float: right; padding-right: 10px;">
    <mat-label>Search Users</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Search Users" #input>
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
  <table class="table__inner" mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="User">
      <th mat-header-cell *matHeaderCellDef>User</th>
      <td mat-cell *matCellDef="let row;let element">
        {{ element?.username }}
      </td>
    </ng-container>

    <ng-container matColumnDef="FullName">
      <th mat-header-cell *matHeaderCellDef>Full Name</th>
      <td mat-cell *matCellDef="let row;let element;"> {{ element?.firstName + ' ' + element?.lastName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="ReaderFor">
      <th mat-header-cell *matHeaderCellDef>Reader For</th>
      <td mat-cell *matCellDef="let row;let element;">
        <button matTooltip="Select Libraries to grant READER ACCESS" mat-raised-button color="primary" (click)="openReader(element?.username)">Select Folders</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="InitiatorFor">
      <th mat-header-cell *matHeaderCellDef>Initiator For</th>
      <td mat-cell *matCellDef="let row;let element;">
        <button matTooltip="Select Libraries to grant INITIATOR ACCESS" mat-raised-button color="primary" (click)="openInitiator(element?.username)">Select Folders</button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row;let element; columns: displayedColumns" [ngClass]="{indirectRow:!row.direct}" ></tr>
  </table>
</div>
<mat-paginator class="table__pagination" [pageSizeOptions]="[100,50,10,5]"></mat-paginator>
</mat-card>